import * as React from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface CerebroHeadingProps extends Omit<TypographyProps, 'variant' | 'component' | 'ref'> {
	size?: 'h1' | 'h2' | 'h3';
	component?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export const CerebroHeading: React.FC<CerebroHeadingProps> = ({ size = 'h1', component, children, ...props }) => {
	if (!component) component = size;

	return (
		<Typography variant={size} component={component} {...props}>
			{children}
		</Typography>
	);
};
